// Used to test with dev site API, DO NOT commit this
// const API_URL = process.env.REACT_APP_API_URL || 'https://coriolis-otfp-kosmos-api-dev.azurewebsites.net/';
// const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'https://coriolis-otfp-kosmos-api-dev.azurewebsites.net/hubs/chat';

// Used to test with stg site API, DO NOT commit this
// const API_URL = process.env.REACT_APP_API_URL || 'https://coriolis-otfp-kosmos-staging.azurewebsites.net/';
// const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'https://coriolis-otfp-kosmos-staging.azurewebsites.net/hubs/chat';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:44326';
const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || 'https://localhost:44326/hubs/chat';

const drawerWidth = 280;

const SUSTAINABILITY_COLOR = [
  '#ff7a95', // 0-100
  '#ff8867',
  '#ff953d',
  '#fea529',
  '#e5b130',
  '#c6be68',
  '#a4caaa',
  '#80d0c8',
  '#5accbb',
  '#27c8a8', // 901-1000
];

const getSustainabilityScoreColor = (score: number): string | undefined => {
  if (score < 0 || score > 1000) return undefined;
  return SUSTAINABILITY_COLOR[Math.floor(score / 100)];
};

// azure aadb2c settings
const AZURE_B2C_CONFIG = {
  redirectPath: process.env.REACT_APP_REDIRECT_PATH || '/home',
  logoutRedirectPath: process.env.REACT_APP_POST_LOGOUT_REDIRECT_PATH || '/',
  simpleSignup: 'disable',
};

const smartGovernancePrimaryColor = '#3544d0';

const NEGATIVE_OPTION_ALIAS = 'n-a';

export {
  AZURE_B2C_CONFIG,
  SUSTAINABILITY_COLOR,
  API_URL,
  WEBSOCKET_URL,
  getSustainabilityScoreColor,
  drawerWidth,
  smartGovernancePrimaryColor,
  NEGATIVE_OPTION_ALIAS,
};
